import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function TermsPage() {
  const { t } = useLanguage();
  return (
    <div className="px-6 md:px-12 max-w-4xl mx-auto py-12 md:py-20" data-testid="terms-page">
      <h1 className="text-4xl font-bold text-white font-['Outfit'] tracking-tight mb-8">{t('footer.terms')}</h1>
      <div className="bg-[#0A0A0A] border border-white/5 rounded-sm p-8 md:p-12 space-y-6 text-zinc-400 text-sm leading-relaxed">
        <p className="text-zinc-500 text-xs">Last updated: February 2026</p>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">1. Agreement to Terms</h2>
          <p>By accessing and using XDomainX.com ("the Platform"), you agree to be bound by these Terms of Service. The Platform is owned and operated by <strong className="text-white">Liber nostra d.o.o.</strong> If you do not agree with these terms, please discontinue use of the Platform immediately.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">2. Services</h2>
          <p>XDomainX.com provides a domain name marketplace platform that enables users to buy, sell, auction, rent, and manage domain names. Our services include but are not limited to: domain listings, live auctions, domain valuation, domain brokerage, Domain Garden program, and domain rental services.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">3. User Accounts</h2>
          <p>To access certain features, you must create an account. You are responsible for maintaining the confidentiality of your account credentials. You must provide accurate and complete information during registration. You may not create accounts for fraudulent or illegal purposes.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">4. Domain Transactions</h2>
          <p>All domain transactions are facilitated through our escrow service. Buyers agree to pay the listed price or winning auction bid. Sellers agree to transfer domain ownership within the specified timeframe. XDomainX charges a commission of 10-15% on completed transactions. All prices are displayed in the currency specified and are subject to applicable taxes.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">5. Auctions</h2>
          <p>Bids placed in auctions are binding commitments. The highest bidder at auction close is obligated to complete the purchase. Bid sniping protections may extend auction end times. Reserve prices, if set, must be met for the auction to result in a sale.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">6. Domain Garden Program</h2>
          <p>The Domain Garden program allows users to transfer management of their domains to XDomainX for a period of one year. Users may reclaim their domain within the one-year period by paying 10% of the renewal cost. Domains not reclaimed after one year become the permanent property of XDomainX.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">7. Payments</h2>
          <p>Payments are processed through secure third-party payment providers (myPOS, Stripe). All financial transactions are encrypted and PCI-DSS compliant. Refunds are handled on a case-by-case basis in accordance with our refund policy.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">8. Intellectual Property</h2>
          <p>All content on XDomainX.com, including design, text, graphics, and software, is the property of Liber nostra d.o.o. and is protected by applicable intellectual property laws.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">9. Limitation of Liability</h2>
          <p>XDomainX.com and Liber nostra d.o.o. shall not be liable for any indirect, incidental, or consequential damages arising from use of the Platform. Our total liability shall not exceed the amount paid by you in the twelve months preceding the claim.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-3">10. Contact</h2>
          <p>For questions about these Terms, contact us at:<br/>
          <strong className="text-white">Liber nostra d.o.o.</strong><br/>
          Email: info@xdomainx.com</p>
        </section>
      </div>
    </div>
  );
}
